var _require = require('../data-set'),
    registerTransform = _require.registerTransform;

registerTransform('default', function (dataView) {
  return dataView;
});


//////////////////
// WEBPACK FOOTER
// ./src/transform/default.js
// module id = 398
// module chunks = 0